import gql from 'graphql-tag'

export default gql`
  mutation removeEnterpriseMember($email: String!) {
    removeEnterpriseMember(email: $email) {
      email
      payerUser {
        id
        email
        firstname
        lastname
        stripeCustomerId
      }
    }
  }
`
